const getPromoBannerElement = () =>
  document.querySelector('[data-xc="PromotionBanner"]');

export default getPromoBannerElement;
